import { Button, Checkbox, Form, Input, Select, Tabs } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import Ledger from "./Ledger";
import TrackingLinks from "./TrackingLinks";
import TrackingStats from "./TrackingStats";
import { getCommission } from "../../feature/commission-program/commissionApi";
import { authSelector } from "../../feature/auth/authSelector";
import { handleErrorSaga } from "../../utils/helper";
import {
  checkProvidedW9FormRequest,
  getReferralPartnerByIdRequest,
  getStatusEmailSentW9FormRequest,
  sendEmailW9FormRequest,
  updateReferralPartnerRequest,
} from "../../feature/referral-partners/referralPartnerSlice";
import {
  partnerInfoSelector,
  referralPartnerSelector,
} from "../../feature/referral-partners/referralPartnerSelector";
import CouponCodes from "./CouponCodes";
import W9Form from "./W9Form";

const DetailReferralPartner = ({ isPartner }) => {
  const [listCommission, setListCommission] = useState([]);
  const { userState } = useSelector(({ authState }) => authSelector(authState));
  const { partnerInfo, isUpdateReferralPartner } = useSelector(
    ({ referralPartnersState }) => partnerInfoSelector(referralPartnersState)
  );
  const {
    isGetStatusEmailSentW9Form,
    isSendingEmailW9Form,
    isSentEmailW9Form,
  } = useSelector(({ referralPartnersState }) =>
    referralPartnerSelector(referralPartnersState)
  );
  const [isProvided, setIsProvided] = useState(false);
  const dispatch = useDispatch();
  const id = useLocation()?.state?.id;
  const [form] = Form.useForm();

  const onFormFinish = (values) => {
    delete values.email;
    delete values.code;
    if (isPartner) {
      delete values.commissionPrograms;
    }
    const paypalEmail = values.paypalEmail.toLowerCase().replace(/\s/g, "");
    form.setFieldsValue({ paypalEmail });
    dispatch(
      updateReferralPartnerRequest({
        ...values,
        paypalEmail,
        _id: isPartner ? userState._id : id,
      })
    );
  };

  const emailW9Form = () => {
    dispatch(sendEmailW9FormRequest(partnerInfo._id));
  };

  const checkProvidedW9Form = (checked) => {
    dispatch(
      checkProvidedW9FormRequest({ partnerId: partnerInfo._id, checked })
    );
  };

  useEffect(() => {
    getCommission()
      .then((res) => setListCommission(res.data))
      .catch((error) => handleErrorSaga(error));
  }, []);

  useEffect(() => {
    if (isPartner && userState?._id) {
      dispatch(getReferralPartnerByIdRequest(userState._id));
    }
    if (!isPartner && id) {
      dispatch(getReferralPartnerByIdRequest(id));
    }
    // eslint-disable-next-line
  }, [isPartner, userState]);

  useEffect(() => {
    listCommission.length > 0 &&
      partnerInfo &&
      partnerInfo.commissionPrograms &&
      form.setFieldsValue({
        ...partnerInfo,
        commissionPrograms: partnerInfo.commissionPrograms.map(
          (item) => item._id
        ),
      });
  }, [listCommission, partnerInfo, form]);

  useEffect(() => {
    if (partnerInfo?._id) {
      dispatch(getStatusEmailSentW9FormRequest(partnerInfo._id));
    }
    setIsProvided(partnerInfo.isProvided);
    // eslint-disable-next-line
  }, [partnerInfo]);

  return (
    <div className="detail-referral-partner-container">
      <div className="title-page">{`Referral Partner: ${
        partnerInfo?.firstName || ""
      } ${partnerInfo?.lastName || ""}`}</div>

      <Form
        form={form}
        className="partner-info-container mt-25"
        onFinish={onFormFinish}
      >
        <div className="partner-info">
          <Form.Item
            name="firstName"
            rules={[
              { required: true, message: "Please input your first name!" },
            ]}
            label="First Name"
            className="form-input"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="lastName"
            rules={[
              { required: true, message: "Please input your last name!" },
            ]}
            label="Last Name"
            className="form-input"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="code"
            rules={[
              {
                required: true,
                message: "Please input your referral partner code!",
              },
            ]}
            label="Referral Partner Code"
            className="form-input"
          >
            <Input disabled />
          </Form.Item>
          <Form.Item
            name="email"
            rules={[
              {
                required: true,
                message: "Please input your email!",
              },
            ]}
            label="Email"
            className="form-input"
          >
            <Input disabled />
          </Form.Item>
          <Form.Item
            name="companyName"
            label="Company / Organization"
            className="form-input"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="paypalEmail"
            rules={[
              { required: true, message: "Please input your PayPal email!" },
            ]}
            label="PayPal Email"
            className="form-input"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="paypalName"
            label="PayPal Name"
            className="form-input"
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="commissionPrograms"
            label="Commission Programs"
            className="form-input expand"
          >
            <Select className="w-100-p" mode="multiple" disabled={isPartner}>
              {listCommission.map((item) => (
                <Select.Option key={item._id} value={item._id}>
                  {item.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name="password" label="Password" className="form-input">
            <Input autoComplete="new-password" type="password" />
          </Form.Item>
        </div>
        <div className="save-button">
          <div className="d-flex">
            <Button
              type="primary"
              className="ml-5"
              htmlType="submit"
              loading={isUpdateReferralPartner}
            >
              Save
            </Button>
            <Checkbox
              className="cb-w9"
              checked={isProvided}
              disabled={isPartner}
              onChange={(e) => {
                !isPartner && setIsProvided(e.target.checked);
                !isPartner && checkProvidedW9Form(e.target.checked);
              }}
            >
              <div style={{ color: "#000" }}>Provided W-9 Form</div>
            </Checkbox>
          </div>
          {!isPartner && (
            <div className="send-email">
              <div className="ml-5">{`Status: ${
                isGetStatusEmailSentW9Form
                  ? "..."
                  : isSentEmailW9Form
                  ? "Email sent"
                  : "Not sent yet"
              }`}</div>
              <Button
                type="primary"
                className="ml-5 btn-send-email"
                loading={isUpdateReferralPartner || isSendingEmailW9Form}
                onClick={() => emailW9Form()}
              >
                Email W-9 Form Request
              </Button>
            </div>
          )}
        </div>
      </Form>

      <div className="tab-container mt-25">
        <Tabs defaultActiveKey="1" destroyInactiveTabPane>
          <Tabs.TabPane tab="Ledger" key="1">
            <Ledger isPartner={isPartner} id={isPartner ? userState._id : id} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Links Stats" key="2">
            <TrackingStats id={isPartner ? userState._id : id} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Referral Links" key="3">
            <TrackingLinks id={isPartner ? userState._id : id} />
          </Tabs.TabPane>
          <Tabs.TabPane tab={"Coupon Codes & Notes"} key="4">
            <CouponCodes
              isPartner={isPartner}
              id={isPartner ? userState._id : id}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="W9-Form" key="5">
            <W9Form id={isPartner ? userState._id : id} />
          </Tabs.TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default DetailReferralPartner;
